import { mapGetters } from 'vuex'
export default {
    props:
    {
        item:Object,
    },
    computed:
    {
        ...mapGetters({
            layouts: 'layouts',
        }),
        itemLayout: 
        {
            get() 
            {
                if (this.item && this.item.layouts && this.item.layouts.length > 0)
                    return this.item.layouts[0]
            },
            set(val) 
            {
                this.item.layouts = []
                this.item.layouts.push(val)
            },
        },
    },
    watch: 
    {
        '$route':
        {
            handler()
            {
                this.setData()
            },
            immediate: true
        },
    },
    methods: {
        setData()
        {
            this.getLayouts()
        },
        getLayouts()
        {
            this.$store.dispatch('layoutsFetch')
        },
        preview()
        {
            this.$store.dispatch(this.action.update, this.item).then(res => {
                window.location.href = `${process.env.FRONTEND_URL}/preview/${this.item.url}`
            })
        },
        addDesktopImage(file)
        {
            this.item.desktop_images.length = 0
            this.item.desktop_images.push(file)
        },
        addMobileImage(file)
        {
            this.item.mobile_images.length = 0
            this.item.mobile_images.push(file)
        },
        save()
        {
            if (this.dirty) {
                this.$refs.confirmModal.openModal()
            } else {
                this.$store.dispatch(this.action.update, this.item).then(res=>{
                    this.$emit('saved')
                })
            }
        },
        discard()
        {
            this.$router.push({ name: this.subPageName, params: {slug: 'live', page: 1, order: 'asc', sort: this.id}})
        },
        setDirty()
        {
            this.$store.dispatch(this.action.setDirty, true)
        },
        setClean()
        {
            this.$store.dispatch(this.action.setDirty, false)
        },
    },
    data()
    {
        return {
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                ['image', 'code-block']
            ],
        }
    },
    mounted()
    {
        this.$root.setLayout('layout-main')
    },
   
}



// WEBPACK FOOTER //
// ./src/mixins/edit/Creative.js